<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
            <app-navbar></app-navbar>

            <div class="container-fluid mt-5">
                <!-- Title and Breadcrumb Starts 
          <div class="row">
            <div class="col-sm-12 print-media">
              <vs-breadcrumb
                align="left"
                :items="[
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Admin/adminDashboard',
                  },
                  {
                    title: 'Certificate',
                    active: true,
                  },
                ]"
              ></vs-breadcrumb>
            </div>
          </div> -->

                <div class="row">
                    <div class="col-sm-12 print-scr">
                        <vs-breadcrumb align="left" :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/program-officer/todoList'
                  },

                  {
                    title: 'Event Wizard',

                  },
                  {
                    title: ` ${trainingTitle}`,
                    active: true,
                    class: 'font-bold'
                  }
                ]"></vs-breadcrumb>
                    </div>
                    <div class="col-sm-12">
                        <div class="heading mt-2">
                            <h3 class="text-secondary">Certificate Editor</h3>
                        </div>
                    </div>
                </div>
                <!-- breadcrumb and title row Ends -->
                <div class="row justify-content-center mt-0">
                    <div class="col-11 text-center p-0 mt-1 mb-2">
                        <div class="card px-0 pb-0 mt-3 mb-3">
                            <div class="row">
                                <div class="col-md-12 mx-0">
                                    <form id="msform">
                                        <!-- progressbar -->
                                        <ul id="progressbar">
                                            <li title="Warning! You are not authorized to access." id="PoAssignment">
                                                <strong>P.O Assignment</strong>
                                            </li>
                                            <li @click="trainingInformation()" class="completed" id="TrainingInformation">
                                                <strong>Event Information</strong>
                                            </li>
                                            <li @click="trainerRegistration()" class="completed" id="TrainerRegistration">
                                                <strong>Facilitators' Registration</strong>
                                            </li>
                                            <li @click="trainingAgenda()" class="completed" id="TrainingAgenda">
                                                <strong>Event Agenda</strong>
                                            </li>
                                            <li @click="trainingMaterial()" class="completed" id="Trainingmaterial">
                                                <strong>Upload Material</strong>
                                            </li>
                                            <li @click="trainingAssessment()" class="completed" id="TrainingAssessments">
                                                <strong>Assessments</strong>
                                            </li>

                                            <li @click="traineeReg()" class="completed" id="TraineeRegistration">
                                                <strong>Participants' Registration</strong>
                                            </li>
                                            <li @click="assessmentReviewFunction()" class="completed" id="AssessmentReview">
                                                <strong>Review</strong>
                                            </li>
                                            <li class="completed" @click="trainingCompletion()" id="Completion">
                                                <strong>Completion</strong>
                                            </li>
                                            <li class="active" id="Certificate">
                                                <strong>Certificate</strong>
                                            </li>
                                        </ul>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <CertificateEditor /> -->

                <div class="container-fluid">
                <iframe
                  id="analytics-iframe"
                  v-if="iframeAllowed"
                  :src="iframeUrl"
                  width="100%"
                  height="900"
                  frameborder="0"
                ></iframe>
              </div>

            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
// import CertificateEditor from "../../commonPages/CertificateEditor"
import axios from "axios";

export default {
    data: () => ({
        isSidebar: false,
        trainingTitle: "",
        iframeAllowed: false,
        eventId: '',
        iframeUrl: '',
    }),
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
        // CertificateEditor
    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios.get(process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode
            )
            .then(response => {
                
                this.trainingTitle = response.data?.training?.title;
                this.eventId = response.data?.training?.id ;
                const basePath = process.env.VUE_APP_BASE_PATH;
                         if (basePath.includes("dev.tmisodc.org")) {
                           this.iframeUrl = `https://www.dev.tmisodc.org/certificates/certificate_specimen.php?trainingId=${this.eventId}`;
                         } else {
                           this.iframeUrl = `https://www.tmisodc.org/certificates/certificate_specimen.php?trainingId=${this.eventId}`;
                         }
                this.iframeAllowed = true;
                this.closeLoading();
            });

    },
    methods: {
        trainingInformation() {
            this.$router.push({
                path: '/dashboard/programOfficer/training-information',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainerRegistration() {
            this.$router.push({
                path: '/dashboard/programOfficer/trainer-registration',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingAgenda() {
            this.$router.push({
                path: '/dashboard/programOfficer/training-agenda',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingMaterial() {
            this.$router.push({
                path: '/dashboard/programOfficer/wizardUploadMaterial',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingAssessment() {
            this.$router.push({
                path: '/dashboard/programOfficer/training-assesment',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        traineeReg() {
            this.$router.push({
                path: '/dashboard/programOfficer/trainee-registration',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        assessmentReviewFunction() {
            this.$router.push({
                path: '/dashboard/programOfficer/assesment-review',
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingCompletion() {

            this.$router.push({
                path: "/dashboard/programOfficer/wizard-completion",
                query: {
                    trainingId: this.trainingCode
                }
            });

        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
    }
};
</script>

<style scoped>
#menu-toggle {
    display: none;
}

.print-media {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

.vs-breadcrumb {
    font-size: 18px !important;
    font-weight: 600 !important;
}

.white-text {
    color: #ffffff;
}

#progressbar .completed {
    color: #06a6e0 !important;
}

#progressbar li.completed:before,
#progressbar li.completed:after {
    background: #06a6e0 !important;
}

#grad1 {
    background-color: #fff;
}

#msform {
    text-align: center;
    position: relative;
    margin-top: 20px;
}

#msform fieldset .form-card {
    background: white;
    border: 0 none;
    border-radius: 0px;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    padding: 20px 40px 30px 40px;
    box-sizing: border-box;
    width: 94%;
    margin: 0 3% 20px 3%;
    position: relative;
}

#msform fieldset {
    padding: 10px;
    background: #f7f7f7 !important;
    border: 0 none;
    border-radius: 2rem;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    border: 2px solid #ccc;
    padding-bottom: 20px;
    position: relative;
}

#msform fieldset:not(:first-of-type) {
    display: none;
}

#msform fieldset .form-card {
    text-align: left;
    color: #9e9e9e;
}

#msform .action-button {
    width: 100px;
    background: skyblue;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
    width: 100px;
    background: #616161;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
    border: none;
    outline: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 5px 3px 5px;
    margin: 2px;
}

select.list-dt:focus {
    border-bottom: 2px solid skyblue;
}

.card {
    z-index: 0;
    border: none;
    border-radius: 0.5rem;
    position: relative;
}

#progressbar {
    margin-bottom: 30px;
    overflow: hidden;
    color: lightgrey;
}

#progressbar .active {
    color: #000000;
}

#progressbar li {
    list-style-type: none;
    font-size: 12px;
    width: 9.5%;
    text-align: center;
    float: left;
    position: relative;
}

#progressbar #NewTraining:before {
    content: "1";
}

#progressbar #PoAssignment:before {
    content: "2";
}

#progressbar #TrainingInformation:before {
    content: "3";
}

#progressbar #TrainingAgenda:before {
    content: "4b";
}

#progressbar #Trainingmaterial:before {
    content: "4c";
}

#progressbar #TrainingAssessments:before {
    content: "4d";
}

#progressbar #TrainerRegistration:before {
    content: "4a";
}

#progressbar #TraineeRegistration:before {
    content: "4e";
}

#progressbar #AssessmentReview:before {
    content: "5";
}

#progressbar #Completion:before {
    content: "6";
}

#progressbar #Certificate:before {
    content: "7";
}

#progressbar li:before {
    width: 35px;
    height: 35px;
    line-height: 30px;
    display: block;
    font-size: 18px;
    color: #ffffff;
    background: lightgray;
    border-radius: 50%;
    margin: 0 auto 10px auto;
    padding: 2px;
}

#progressbar li:after {
    content: "";
    width: 100%;
    height: 2px;
    background: lightgray;
    position: absolute;
    left: 0;
    top: 17px;
    z-index: -1;
}

#progressbar li.active:before,
#progressbar li.active:after {
    background: #000000;
}
</style>
